import {type} from '@ngrx/signals';
import {event, EventCreator, EventInstance} from '@ngrx/signals/events';
import {CqrsCommand, CqrsEvent, CqrsQuery} from '@scalified-monorepo/shared';
import {filter, map, pipe} from 'rxjs';

export const CqrsCommandFactory = <T extends CqrsCommand>(commandType?: string) =>
  event(`[CQRS] Send Command${commandType ? ' ' + commandType : ''}`, type<T>());

export const CqrsCommandSuccessFactory = <T>(commandType?: string) =>
  event(`[CQRS] Command${commandType ? ' ' + commandType : ''} success`, type<T>());

export const CqrsCommandAcceptedFactory = (commandType?: string): EventCreator<string, {traceId: string}> =>
  event(`[CQRS] Command${commandType ? ' ' + commandType : ''} accepted`, type<{traceId: string}>());

export const CqrsCommandErrorType = 'CqrsCommandFailed';

export const CqrsQueryFactory = <T extends CqrsQuery>(queryType?: string) =>
  event(`[CQRS] Send Query${queryType ? ' ' + queryType : ''}`, type<T>());

export const CqrsQuerySuccessFactory = <T>(queryType?: string) =>
  event(`[CQRS] Query${queryType ? ' ' + queryType : ''} success`, type<T>());

export const CqrsQuerySuccessWithContextFactory = <T>(queryType?: string) =>
  event(
    `[CQRS] Query${queryType ? ' ' + queryType : ''} success (context)`,
    type<{response: T; queryContext: string}>()
  );

export const CqrsQueryErrorType = 'CqrsQueryFailed';

export function withQueryContext<T>(queryContext: string) {
  return pipe(
    filter(
      (event: EventInstance<string, {response: T; queryContext: string}>) => event.payload.queryContext === queryContext
    ),
    map(event => event.payload.response)
  );
}

export function eventsForTypes<T extends CqrsCommand | CqrsQuery | CqrsEvent | void | unknown>(
  eventFactory: (type?: string) => EventCreator<string, T>,
  typeEnum: Record<string, string>
): EventCreator<string, T>[];
export function eventsForTypes<T extends CqrsCommand | CqrsQuery | CqrsEvent | void | unknown>(
  eventFactory: (type?: string) => EventCreator<string, T>,
  typeArray: string[]
): EventCreator<string, T>[];
export function eventsForTypes<T extends CqrsCommand | CqrsQuery | CqrsEvent | void | unknown>(
  eventFactory: (type?: string) => EventCreator<string, T>,
  typeEnumOrArray: Record<string, string> | string[]
) {
  const types = Array.isArray(typeEnumOrArray) ? typeEnumOrArray : Object.values(typeEnumOrArray);
  return types.map(type => eventFactory(type));
}
